class BayrawProductPage extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-product-form]');
    this.variantInput = this.querySelector('[name="id"]');
    this.atc = this.querySelector('[data-atc]');
    this.stock = this.querySelector('[data-stock]');
    this.price = this.querySelector('[data-price]');
    this.comparePrice = this.querySelector('[data-compare-price]');
    this.badge = this.querySelector('[data-saving-badge]');
    this.mobileBar = document.querySelector(`[data-mobile-bar="${this.dataset.sectionId}"]`);
    this.variants = JSON.parse(this.querySelector('[data-variants-json]')?.textContent || '[]');

    this.querySelectorAll('[data-option-input]').forEach(input => {
      input.addEventListener('change', () => this.updateVariant());
    });

    this.querySelectorAll('[data-gallery-thumb]').forEach(button => {
      button.addEventListener('click', () => this.goToSlide(Number(button.dataset.galleryThumb)));
    });

    const track = this.querySelector('[data-gallery-track]');
    if (track) track.addEventListener('scroll', () => this.updateGalleryCounter(), { passive: true });

    if (this.mobileBar && this.atc) {
      const observer = new IntersectionObserver(entries => {
        const visible = !entries[0].isIntersecting && window.scrollY > 300;
        this.mobileBar.classList.toggle('is-visible', visible);
      }, { threshold: 0.1 });
      observer.observe(this.atc);
      this.mobileBar.querySelector('button')?.addEventListener('click', () => this.atc.click());
    }
  }

  selectedOptions() {
    return [...this.querySelectorAll('[data-option-group]')].map(group => {
      return group.querySelector('[data-option-input]:checked')?.value;
    });
  }

  updateVariant() {
    const selected = this.selectedOptions();
    const variant = this.variants.find(v => v.options.every((option, index) => option === selected[index]));
    if (!variant) return;

    this.variantInput.value = variant.id;
    this.atc.disabled = !variant.available;
    this.atc.textContent = variant.available ? this.atc.dataset.availableText : this.atc.dataset.soldText;
    this.stock.textContent = variant.available ? this.stock.dataset.inText : this.stock.dataset.outText;
    this.stock.classList.toggle('brp-stock--out', !variant.available);
    this.price.textContent = this.formatMoney(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      this.comparePrice.hidden = false;
      this.comparePrice.textContent = this.formatMoney(variant.compare_at_price);
      if (this.badge) this.badge.hidden = false;
    } else {
      this.comparePrice.hidden = true;
      if (this.badge) this.badge.hidden = true;
    }

    if (variant.featured_media?.position) this.goToSlide(variant.featured_media.position - 1);
    if (this.mobileBar) this.mobileBar.querySelector('[data-mobile-price]').textContent = this.formatMoney(variant.price);

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  formatMoney(cents) {
    const currency = this.dataset.currency || 'GBP';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency }).format(cents / 100);
  }

  goToSlide(index) {
    const track = this.querySelector('[data-gallery-track]');
    const slide = track?.children[index];
    slide?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    this.querySelectorAll('[data-gallery-thumb]').forEach((button, i) => button.setAttribute('aria-current', i === index ? 'true' : 'false'));
  }

  updateGalleryCounter() {
    const track = this.querySelector('[data-gallery-track]');
    if (!track || !track.clientWidth) return;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    const counter = this.querySelector('[data-gallery-counter]');
    if (counter) counter.textContent = `${index + 1} / ${track.children.length}`;
    this.querySelectorAll('[data-gallery-thumb]').forEach((button, i) => button.setAttribute('aria-current', i === index ? 'true' : 'false'));
  }
}

if (!customElements.get('bayraw-product-page')) customElements.define('bayraw-product-page', BayrawProductPage);
